// Libraries
var React = require('react');

// Styles
require('./Event.scss');

class Event extends React.Component {	
	handleClick = () => {
		this.props.onEventClick(this.props.event);
	}
	
	render() {
		let eventClass = "";
		if (this.props.event.group.every(x => x.type.toLowerCase() === "penaltyshot" && x.isShootOut)) {
			eventClass = this.props.event.group[0].outcome.toLowerCase() === "scored" ? " Event__goal" : " Event__saved";
			eventClass = eventClass.concat(this.props.selectEvent && this.props.event.id === this.props.selectedEvent ? " white" : "");
		} else if(this.props.event.group.length > 1) {
			eventClass = this.props.event.group.some(x => x.type.toLowerCase() === "goal") ? " Event__group-with-goal" : " Event__group";
			eventClass = eventClass.concat(this.props.selectEvent && this.props.event.group.some(x => x.id === this.props.selectedEvent) ? " white" : "");
		} else {
			eventClass = " Event__" + this.props.event.group[0].type.toLowerCase();
			eventClass = eventClass.concat(this.props.selectEvent && this.props.event.id === this.props.selectedEvent ? " white" : "");
		}

		eventClass = eventClass.concat(this.props.event.group[0].isHome ? " home" : " away");

		if(this.props.event.group.length > 1) {
			return <button className={"Event" + eventClass} onClick={this.handleClick} style={{ left: this.props.event.position }}>{this.props.event.group.length}</button>
		} else {
			return <button className={"Event" + eventClass} onClick={this.handleClick} style={{ left: this.props.event.group[0].position }}></button>
		}
	}
}

module.exports = Event;



// WEBPACK FOOTER //
// ./src/components/MDC/Timeline/Event.js